// USER
export const SET_USER = 'set_user';
export const SET_PHOTO_URL = 'set_photo_url';

// CHAT ROOM
export const SET_CURRENT_CHAT_ROOM = 'set_current_chat_room';
export const SET_PRIVATE_CHAT_ROOM = 'set_private_chat_room';
export const SET_USER_POSTS = 'set_user_posts';
